<template>

    <div class="w-100 h-100 d-flex flex-column justify-content-center align-items-center">

        <h1>Estamos na página em Vuejs</h1>
        <h2>{{ testdata }}</h2>

        <!-- Response Messages -->
        <div class="responsebasemessage" ref="responsebasemessage">

            <list-message/>

        </div>

        <div style="height:1000px">.</div>

        

    </div>


</template>
<script>

import ListMessage from './../../elements/ListMessageElement.vue';
import responseMessage from './../../../responseMessage';

export default{
    name: 'Test',
    props:{

        testdata:{
            type: String,
            required: true
        }
      
    },
    data: () => {

        return{

            activeclass: 'd-flex',

        }

    },
    mounted(){

        //success, danger, warning
        //Add active Class
        this.$refs.responsebasemessage.classList.add(this.activeclass);
        this.$refs.responsebasemessage.classList.add('warning');

        //Element for append
        let li = responseMessage.messageStructure('lorem ipsum dolor sit amet ipsum dolor sit amet', 'warning');

        //Append Element
        $(li).appendTo(this.$refs.responsebasemessage.children);

    },
    components:{

        listMessage: ListMessage,

    }
}

</script>